import { ReactElement, ReactNode } from "react";
import Toast from "@ingka/toast";

import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/toast/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaToastWithActionProps = {
  actionButtonText: ReactNode;
  actionClick: () => void;
  ariaLabel: string;
};

type FixaToastWithoutActionProps = {
  actionButtonText?: undefined;
  actionClick?: undefined;
  ariaLabel?: undefined;
};

type FixaToastProps = {
  text: string | ReactElement;
  isOpen: boolean;
  onCloseRequest: () => void;
  ariaLabelCloseBtn?: string;
  className?: string;
} & (FixaToastWithActionProps | FixaToastWithoutActionProps);

export const FixaToast = (props: FixaToastProps) => {
  return <Toast {...props} />;
};
